<template>
    <div class="wrap-position-teams">
        <header-app></header-app>
        <div class="teams-bg"></div>
        <div class="teams-desc animation">
            <div class="img animation" >
                <img :src="info.img"/>
            </div>
            <h3 class="title">{{info.lastname}} {{info.firstname}}</h3>
            <p class="desc" v-html="info.introduce"></p>
        </div>
        <div class="team-board animation">
            <h3 class="title">BOARD OF DIRECTORS</h3>
            <ul class="board-list">
                <li class="board-item" v-for="(item,index) in board" :key="index">
                    <img :src="item.img" />
                    <p class="txt">{{item.lastname}} {{item.firstname}}({{item.region}})</p>
                </li>
            </ul>
        </div>
        <div class="team-member animation">
            <div class="clients-center-nav">
                <div class="clients-nav-item" @click="changeItem(item)" :class="{'clients-nav-item-active':area == item.area}"  v-for="(item,index) in member" :key="index">{{item.area}}</div>
            </div>
            <div class="member-list">
                <li class="member-item" v-for="(item,index) in memberItem" :key="index">
                    <img :src="item.img" />
                    <p class="txt">
                        {{item.lastname}} {{item.firstname}}<br>
                        ({{item.region}})
                    </p>
                </li>
            </div>
        </div>
        <bottom-app></bottom-app>
        <top-scroll></top-scroll>
    </div>
</template>

<script>
    import bottomApp from '@/components/bottomApp.vue'
    import topScroll from '@/components/topScroll.vue'
    import headerApp from '@/components/headerApp.vue'
    export default {
        components: {
            headerApp,
            bottomApp,
            topScroll
        },
        data(){
          return {
              info:{},
              board:[],
              member:[],
              area:'Asia',
              memberItem:[]
          }
        },
        methods:{
            changeItem(item){
                this.area = item.area || 1
                this.memberItem = item.members || []
            }
        },
        created(){
            this.$api.memeberList().then((res)=>{
                if(res){
                    this.info = res.leader || {}
                    this.board = res.director || []
                    this.member = res.region || []
                    this.changeItem(this.member[0])
                }
            })
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-position-teams{
        text-align: left;
        .teams-bg{
            height: 4rem;
            background: url("../../assets/imgs/tp-teams-bg.png") no-repeat top center;
            background-size:100%;
            position: relative;
        }
        .teams-desc{
            padding: 2.5rem .5rem .5rem .5rem;
            box-sizing: border-box;
            background-size: cover;
            box-shadow: 0 0 20px rgba(0,0,0,.2);
            position: relative;
            .img{
                position: absolute;
                width: 3.2rem;
                top: -10%;
                left: 50%;
                margin-left: -1.6rem;
                z-index: 2;
                img{
                    width: 100%;
                }
            }
        }
        .title{
            font-size: .48rem;
            color: #6b6b6b;
            position: relative;
            height: .8rem;
            line-height: .8rem;
            &:after{
                content: '';
                display: inline-block;
                width: 1rem;
                height: .05rem;
                background: #ed1d25;
                position: absolute;
                bottom: 0;
                left: 0;
                animation: line-left-in-long 0.5s ease 0.8s;
                animation-fill-mode: both;
            }
        }
        .desc{
            color: #2d2d2d;
            font-size: .28rem;
            line-height: 1.5;
            padding-top: .3rem;
        }
        .article{
            padding: 0 .5rem .9rem 1.3rem;
            position: relative;
            &:after{
                content: " “ ";
                position: absolute;
                left: .2rem;
                top: .76rem;
                font-size: 1.2rem;
                color: #ed1d25;
            }
            .line{
                color: #2d2d2d;
                font-size: .22rem;
                padding-top: .9rem;
                line-height: .36rem;
            }
        }
        .animation {
            position: relative;
            animation: animation-up 1s ease;
        }

        .team-board{
            padding: .7rem .5rem;
            .board-list{
                font-size: 0;
                line-height: 0;
                margin: .5rem 0 0 0;
                .board-item{
                    display: inline-block;
                    width: 50%;
                    height: 3rem;
                    position: relative;
                    margin-bottom: .3rem;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .txt{
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        height: .8rem;
                        line-height: .8rem;
                        background: rgba(0,0,0,.5);
                        text-align: center;
                        color: #fff;
                        font-size: .3rem;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        padding: 0 .2rem;
                        box-sizing: border-box;
                    }
                }
            }
        }

        .team-member{
            padding: 0 .5rem;
            .clients-center-nav{
                font-size: .22rem;
                color: #858585;
                font-weight: 600;
                overflow: hidden;
                background: #f8f7f7;
                border-radius: .3rem;
                line-height: 0.62rem;
                .clients-nav-item{
                    text-align: center;
                    padding: 0 0.4rem;
                    cursor: pointer;
                    display: inline-block;
                    &:first-child{
                        padding: 0 0.4rem;
                    }
                    &.clients-nav-item-active{
                        background-color: #fff;
                        color: #ec1e25;
                        border-radius: 0.3rem;
                    }
                }
            }
            .member-list{
                font-size: 0;
                line-height: 0;
                margin: .5rem 0 0 0;
                .member-item{
                    display: inline-block;
                    width: 49%;
                    position: relative;
                    margin-bottom: .3rem;
                    margin-right: .1rem;
                    vertical-align: top;
                    &:nth-child(2n){
                        margin-right: 0;
                    }
                    img{
                        width: 100%;
                        height: 3rem;
                    }
                    .txt{
                        width: 100%;
                        padding: .2rem;
                        line-height: .4rem;
                        background:#fff;
                        text-align: center;
                        color: #333;
                        font-size: .3rem;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        box-sizing: border-box;
                    }
                }
            }
        }
        @-webkit-keyframes animation-up{
            0%{bottom: -5rem;}
            100%{bottom: 0;}
        }
    }
</style>
